import {Moment} from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import PositionedPopover from 'ui-library/PositionedPopover';

import {momentPropType} from './CalendarStore';
import NewEntryPopoverContent from './NewEntryPopoverContent';

interface NewEntryPositionedPopoverProps {
  left: number;
  top: number;
  startDate: Moment;
  endDate: Moment;
}

function NewEntryPositionedPopover({
  left,
  top,
  startDate,
  endDate,
}: NewEntryPositionedPopoverProps): JSX.Element {
  return (
    <PositionedPopover className="u-position-fixed" left={left} top={top}>
      <NewEntryPopoverContent startDate={startDate} endDate={endDate} />
    </PositionedPopover>
  );
}

NewEntryPositionedPopover.propTypes = {
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  startDate: momentPropType.isRequired,
  endDate: momentPropType.isRequired,
};

export default NewEntryPositionedPopover;
